import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Global/Icons/Icon';
import TextInput from '../Global/Forms/TextInput';
import Button from '../Global/Buttons/Button';

const LargeSearch = ({ searchTerm, onSearchTermChange, onSearchSubmit, searchLoading }) => (
  <div className="large-search p-a-2 bg-white border-radius-l d-flex flex-row align-items-center box-shadow-l">
    <Icon name="search" fill="grey" classes="large-search__icon flex-shrink-0" />

    <form className="large-search__form w-100 d-flex align-items-center flex-grow-1">
      <TextInput
        name="search"
        value={searchTerm}
        placeholder="Search for topics, themes, coaches, clubs, teams ..."
        onChange={onSearchTermChange}
        classes="m-b-0 flex-grow-1"
        inputClass="faux-input p-a-0"
      />

      <Button type="submit" onClick={onSearchSubmit} classes="large-search__submit" loading={searchLoading}>Search</Button>
    </form>
  </div>
);

LargeSearch.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchTermChange: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  searchLoading: PropTypes.bool.isRequired,
};

export default LargeSearch;



// WEBPACK FOOTER //
// ./library/app/components/Search/LargeSearch.js